import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import format from 'date-fns/format';

const messages = defineMessages({
  save: {
    id: 'secondary.carousel.promotion.save',
    defaultMessage: 'SAVE {percent}%',
  },
  saveup: {
    id: 'secondary.carousel.promotion.saveup',
    defaultMessage: 'SAVE UP TO {percent}%',
  },
  bundle: {
    id: 'secondary.carousel.promotion.bundle',
    defaultMessage: 'NEW BUNDLE',
  },
  outnow: {
    id: 'secondary.carousel.promotion.outnow',
    defaultMessage: 'OUT NOW',
  },
  endingsoon: {
    id: 'secondary.carousel.promotion.endingsoon',
    defaultMessage: 'ENDING SOON',
  },
  preorder: {
    id: 'secondary.carousel.promotion.preorder',
    defaultMessage: 'PRE-ORDER NOW',
  },
  coupon: {
    id: 'secondary.carousel.promotion.coupon',
    defaultMessage: 'WITH COUPON',
  },
  outdate: {
    id: 'secondary.carousel.promotion.outdate',
    defaultMessage: 'OUT',
  },
});

const SecondaryMessage = ({
  customMessage,
  messageType,
  messageData,
  intl: { formatMessage },
}) => {
  if (!messageType || messageType === 'none') {
    return '';
  }

  if (messageType === 'coupon' && messageData && messageData.secondary_coupon) {
    return (<div>{formatMessage(messages.coupon)}: <span className="orange-text">{messageData.secondary_coupon}</span></div>);
  }

  if (messageType === 'outdate' && messageData && messageData.secondary_release_date) {
    const shortDate = format(messageData.secondary_release_date, 'DD/MM/YY');
    return (<div>{formatMessage(messages.outdate)}: <span className="orange-text">{shortDate}</span></div>);
  }

  if (messageType === 'custom') {
    return customMessage;
  }

  return formatMessage(messages[messageType]);
};


SecondaryMessage.propTypes = {
  customMessage: PropTypes.string,
  messageType: PropTypes.string,
  messageData: PropTypes.shape({}),
  formatMessage: PropTypes.func,
};

SecondaryMessage.defaultProps = {
  customMessage: '',
  messageType: '',
  messageData: {},
  formatMessage: () => {},
};

export default injectIntl(SecondaryMessage);
